import React from 'react';


import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionReviewText = props => {
  const { title, options, intl } = props;
  return (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {title}
      </Heading>
      <ul className={css.details}>
        {options.map((o, i) => {
          return (
            <div className={css.reviewContainer} key={i}>
              {o.title &&
                <p className={css.reviewName}>{o.title}</p>
              }
              {o.value &&
                <p className={css.reviewText}>{o.value}</p>
              }
            </div>
          )
        })}
      </ul>
    </section>
  )
};

export default SectionReviewText;
